import * as Yup from "yup";
import { TranslateFunction } from "../../../contexts/LocalizationContext";

export const commentValidationSchema = (translate: TranslateFunction) =>
  Yup.object().shape({
    description: Yup.string()
      .required(translate("validation.fieldRequired"))
      .min(20, translate("validation.minimumCharacters"))
  });
